import { render, staticRenderFns } from "./WidgetInformations.vue?vue&type=template&id=4dcb5a94&scoped=true&"
import script from "./WidgetInformations.vue?vue&type=script&lang=js&"
export * from "./WidgetInformations.vue?vue&type=script&lang=js&"
import style0 from "./WidgetInformations.vue?vue&type=style&index=0&id=4dcb5a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcb5a94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dcb5a94')) {
      api.createRecord('4dcb5a94', component.options)
    } else {
      api.reload('4dcb5a94', component.options)
    }
    module.hot.accept("./WidgetInformations.vue?vue&type=template&id=4dcb5a94&scoped=true&", function () {
      api.rerender('4dcb5a94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Accueil/WidgetInformations.vue"
export default component.exports